import React from 'react';
import { fmt, computeSaleRate } from './constants';

// ── KpiStrip ──
// Four minimal headline KPIs:
//   إجمالي الوحدات · نسبة البيع · الصفقات · عمولات الفريق
// Kept intentionally chrome-light for a serious admin view.
function KpiStrip({ stats, deals, lang }) {
  const totalUnits = stats?.total || 0;
  const saleRate = computeSaleRate(stats);
  const totalDeals = deals.length;
  const totalCommissions = deals.reduce(
    (a, d) => a + Number(d.mgr_amt || 0) + Number(d.closer_amt || 0),
    0
  );

  const kpis = [
    {
      label: lang === 'ar' ? 'إجمالي الوحدات' : 'Total Units',
      value: totalUnits,
      color: 'var(--accent)',
    },
    {
      label: lang === 'ar' ? 'نسبة البيع' : 'Sale Rate',
      value: saleRate + '%',
      color: saleRate >= 70 ? '#22c55e' : saleRate >= 40 ? '#f59e0b' : 'var(--accent)',
    },
    {
      label: lang === 'ar' ? 'الصفقات' : 'Deals',
      value: totalDeals,
      color: '#c9a84c',
    },
    {
      label: lang === 'ar' ? 'عمولات الفريق' : 'Team Commissions',
      value: fmt(totalCommissions),
      color: '#3b82f6',
      suffix: 'SAR',
    },
  ];

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 10,
        marginBottom: 14,
      }}
    >
      {kpis.map((k, i) => (
        <div
          key={i}
          className="card"
          style={{
            padding: '12px 14px',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          <span style={{ fontSize: '0.68rem', color: 'var(--text-secondary)', fontWeight: 600 }}>
            {k.label}
          </span>
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              gap: 4,
              direction: 'ltr',
              justifyContent: lang === 'ar' ? 'flex-end' : 'flex-start',
            }}
          >
            <span style={{ fontSize: '1.5rem', fontWeight: 800, color: k.color, lineHeight: 1.1 }}>
              {k.value}
            </span>
            {k.suffix && (
              <span style={{ fontSize: '0.62rem', color: 'var(--text-secondary)', fontWeight: 700 }}>
                {k.suffix}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default KpiStrip;
